/* Vitrine "Vistos recentemente" — histórico do próprio cliente.
   1) Em páginas de produto, registra o handle no localStorage (dedupe, máx 16).
   2) Onde a seção estiver, busca o card real de cada produto via Section Rendering
      (seção jm-vitrine-card-render) e injeta — visual idêntico às outras vitrines.
   Sem histórico (ou só o produto atual), a seção permanece oculta. */
(function () {
  var KEY = 'jm-recent';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }

  // -------- rastreio (roda em qualquer página; grava só nas PDPs) --------
  var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
  var currentHandle = match ? decodeURIComponent(match[1]) : null;
  if (currentHandle) {
    var list = read().filter(function (h) { return h !== currentHandle; });
    list.unshift(currentHandle);
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 16))); } catch (e) {}
  }

  // -------- render --------
  document.querySelectorAll('[data-jm-vistos]').forEach(function (box) {
    if (box.dataset.jmVistosDone) return;
    box.dataset.jmVistosDone = '1';

    var limit = parseInt(box.dataset.limit || '8', 10);
    var handles = read()
      .filter(function (h) { return h !== currentHandle; })
      .slice(0, limit);
    if (!handles.length) return; // segue oculta

    var track = box.querySelector('[data-jm-showcase-track]');
    if (!track) return;

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '?section_id=jm-vitrine-card-render')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (chunks) {
      var html = chunks
        .map(function (chunk) {
          if (!chunk) return '';
          var doc = new DOMParser().parseFromString(chunk, 'text/html');
          var card = doc.querySelector('jm-vitrine-card');
          return card ? card.outerHTML : '';
        })
        .join('');
      if (!html) return;
      track.innerHTML = html;
      box.hidden = false;
      // reprocessa os custom elements injetados e atualiza o carrossel
      requestAnimationFrame(function () {
        if (typeof box.update === 'function') box.update();
      });
    });
  });
})();
